import { trackAppEvent } from "./appTracking";

/** Smart capture events — MUST stay in sync with ANALYTICS_EVENT_NAMES in
 *  ClaryNext-BE/model/analytics_event.js (spec 2026-11-02 §7). */
export type CaptureEventName =
  | "capture_understood"
  | "capture_saved"
  | "capture_kind_changed"
  | "capture_deeper_shown"
  | "capture_deeper_opened"
  | "capture_body_suggested"
  | "capture_body_accepted";

/** Fire-and-forget. Ids, kinds, counts and flags only, never the person's text. */
export function trackCapture(
  name: CaptureEventName,
  data: Record<string, string | number | boolean | null> = {}
): void {
  trackAppEvent(name, data).catch(() => {});
}
